import React, { useEffect, useRef, useCallback, useState } from 'react';
import 'autocompleter/autocomplete.css';
import LocationSearch from './LocationSearch';

const LocationFilter = ({ onLocationChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [mode, setMode] = useState(null); // 'choose' or 'current'
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [selectedLocalLocation, setSelectedLocalLocation] = useState(null);
    const [radius, setRadius] = useState(50);
    const [isRemote, setIsRemote] = useState(null);
    const dropdownRef = useRef(null);
    const onLocationChangeRef = useRef(onLocationChange);

    useEffect(() => {
        onLocationChangeRef.current = onLocationChange;
    }, [onLocationChange]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleMyLocation = useCallback(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setSelectedLocalLocation({
                        type: 'coordinates',
                        latitude,
                        longitude,
                        name: 'Min position'
                    });
                },
                (error) => {
                    console.error('Error getting location:', error);
                }
            );
        }
    }, []);

    const handleOk = () => {
        if (mode === 'current') {
            setSelectedLocation(selectedLocalLocation);
            onLocationChangeRef.current({
                ...selectedLocalLocation,
                distance: radius
            });
        } else if (mode === 'choose') {
            onLocationChangeRef.current(selectedLocation);
        } else {
            onLocationChange.current({
                isRemote: true,
                type: 'remote'
            });
        }
        setIsOpen(false);
    };

    const handleClear = () => {
        setSelectedLocation(null);
        setSelectedLocalLocation(null);
        setMode(null);
        setIsOpen(false)
        setIsRemote(false);
        onLocationChangeRef.current(null);
    };

    if (selectedLocation || isRemote) {
        const l = selectedLocation || selectedLocalLocation;
        return (
            <button className="btn btn-primary d-flex align-items-center" onClick={handleClear}>
                {mode === 'choose' && <i className="fa fa-earth-europe me-2"></i>}
                {mode === 'current' && <i className="fa-solid fa-location-crosshairs me-2"></i>}
                {mode === 'remote' && <i className="fa-solid fa-computer me-2"></i>}
                {mode !== 'remote' && <span className="me-2">{l.name}</span>}
                {mode === 'current' && <span className="me-2">({radius} km)</span>}
                {mode === 'remote' && <span className="me-2">Digitalt möte</span>}
                <i className="fa fa-circle-xmark"></i>
            </button>
        );
    }

    return (
        <div className="location-filter mb-3" ref={dropdownRef}>
            <div className="btn-group">
                <button 
                    className={"btn "  + (mode == "choose" && isOpen && "btn-primary" || "btn-outline-primary")} 
                    onClick={() => {
                        setMode('choose');
                        setIsOpen(!isOpen);
                    }}
                >
                    <i className="fa fa-earth-europe me-2"></i>
                    Välj plats
                </button>
                <button 
                    className={"btn " + (mode == "current" && isOpen && "btn-primary" || "btn-outline-primary")}
                    onClick={() => {
                        setMode('current');
                        setIsOpen(!isOpen);
                        if (!isOpen) {
                            handleMyLocation();
                        } else {
                            setSelectedLocalLocation(null);
                        }
                    }}
                >
                    <i className="fa-solid fa-location-crosshairs me-2"></i>
                    Din position
                </button>
                <button
                    className={"btn " + (mode == "remote" && "btn-primary" || "btn-outline-primary")} 
                    onClick={() => {
                        setMode(prev => {
                            const type = prev === 'remote' ? null : 'remote';
                            onLocationChangeRef.current({
                                isRemote: prev !== 'remote',
                                type: 'remote'
                            })
                            return type;
                        });
                        setIsOpen(false);
                        setIsRemote(true);
                    }}
                >
                    <i className="fa-solid fa-computer me-2"></i>
                    Digitalt möte
                </button>
            </div>

            {isOpen && (
                <div className="card-dropdown card mt-1 bg-white">
                    <div className="card-body">
                        {mode === 'choose' && (
                            <div className="mb-3">
                                <LocationSearch onLocationChange={(selected) => {
                                    setSelectedLocation(selected);
                                    onLocationChangeRef.current(selected);
                                }} 
                                unfocus={() => setIsOpen(false)}/>
                            </div>
                        )}
                        {mode === 'current' && (
                            <div className="mb-3">
                                <label className="form-label">Sökradie (km)</label>
                                <input
                                    type="range"
                                    className="form-range"
                                    min="1"
                                    max="300"
                                    value={radius}
                                    onChange={(e) => setRadius(parseInt(e.target.value))}
                                />
                                <div className="radius-box"><span>{radius} km</span></div>
                            </div>
                        )}
                        <button 
                            className="btn btn-primary w-100"
                            onClick={handleOk}
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LocationFilter; 